:root,
.uic-theme-responsive {
  --uxc-app-header-height: 52px;
  --uxc-app-header-expandables-y-offset: 56px;
  --uxc-app-header-expandables-min-width: 300px;
  --uxc-app-header-z-index: 400;
  --uxc-app-header-bg-color: var(--uic-color-blue5);
  --uxc-app-header-separator-color: var(--uic-color-white);
  --uxc-app-header-launcher-width: 68px;
}

@media only screen and (min-width: 1024px) {
  .uic-theme-responsive {
    --uxc-app-header-height: 68px;
    --uxc-app-header-expandables-y-offset: 72px;
    --uxc-app-header-launcher-width: 85px;
  }
}
:root,
.uic-theme-responsive {
  --uxc-app-toast-notifications-z-index: 350;
}

.uxc-app-language-selector {
  display: block;
}
.uxc-app-language-selector uic-list-item .uic-list-item__content-default {
  line-height: 1.6;
}
.uxc-app-language-selector[slot=user-dialog] {
  --uic-dropdown-variant-content-min-width: 186px;
  margin: 1rem -8px;
  overflow: hidden;
  width: auto;
}